// material-ui
import {} from '@mui/material'

// assets

import CustomerAdministratorComponent from 'components/CustomerAdministratorComponent'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid

  function main(): any {
    return <CustomerAdministratorComponent />
  }

  let output_main = main()

  return output_main
}
